import { render } from "./BroadcastNotify.vue?vue&type=template&id=78c377bf"
import script from "./BroadcastNotify.vue?vue&type=script&lang=js"
export * from "./BroadcastNotify.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Evolve/WorkSpace/MinonowaRadio/Ver2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__